export const OTHER_RACE_CODE = '2131-1';
export const AI_AN_CODE = '1002-5';
export const MIDDLE_EASTERN_RACE_CODE = '2118-8';
export const RACES_LIST = [
    {
        label: 'ssap.input.label.ai_an',
        code: AI_AN_CODE,
        otherLabel:	null,
        altName: 'ai_an'
    },
    {
        label: 'ssap.input.label.asian_indian',
        code: '2029-7',
        otherLabel:	null,
        altName: 'asian_indian'
    },
    {
        label: 'ssap.input.label.black_american',
        code: '2054-5',
        otherLabel:	null,
        altName: 'black_american'
    },
    {
        label: 'ssap.input.label.chinese',
        code: '2034-7',
        otherLabel: null,
        altName: 'chinese'
    },
    {
        label: 'ssap.input.label.filipino',
        code: '2036-2',
        otherLabel: null,
        altName: 'filipino'
    },
    {
        label: 'ssap.input.label.guam_chamorro',
        code: '2086-7',
        otherLabel: null,
        altName: 'guam_chamorro'
    },
    {
        label: 'ssap.input.label.japanese',
        code: '2039-6',
        otherLabel: null,
        altName: 'japanese'
    },
    {
        label: 'ssap.input.label.korean',
        code: '2040-4',
        otherLabel: null,
        altName: 'korean'
    },
    {
        label: 'ssap.input.label.middle_eastern',
        code: MIDDLE_EASTERN_RACE_CODE,
        otherLabel: null,
        altName: 'middle_eastern'
    },
    {
        label: 'ssap.input.label.native_hawaiian',
        code: '2079-2',
        otherLabel: null,
        altName: 'native_hawaiian'
    },
    {
        label: 'ssap.input.label.other_asian',
        code: '2028-9',
        otherLabel: null,
        altName: 'other_asian'
    },
    {
        label: 'ssap.input.label.pacific_islanders',
        code: '2500-7',
        otherLabel: null,
        altName: 'pacific_islanders'
    },
    {
        label: 'ssap.input.label.samoan',
        code: '2080-0',
        otherLabel: null,
        altName: 'samoan'
    },
    {
        label: 'ssap.input.label.vietnamese',
        code: '2047-9',
        otherLabel: null,
        altName: 'vietnamese'
    },
    {
        label: 'ssap.input.label.white',
        code: '2106-3',
        otherLabel: null,
        altName: 'white'
    },
    {
        label: '',
        code: OTHER_RACE_CODE,
        otherLabel: null,
        altName: 'other_race'
    }
];
